import React, { useState } from 'react';
import API from '../api';
import { useTranslation } from '../hooks/useTranslation';
import LanguageSwitcher from './LanguageSwitcher';

export default function Register({ onRegister }) {
  const { getMessage } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    try {
      const res = await API.post('/auth/register', form);
      setMessage(res.data.message);
      onRegister();
    } catch (err) {
      setMessage(`❌ ${getMessage('register.registration_failed')}`);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 relative">
      {/* Language Switcher */}
      <div className="absolute top-4 right-4">
        <LanguageSwitcher compact={true} />
      </div>
      
      <div className="max-w-md w-full mx-4 p-6 bg-white dark:bg-gray-800 shadow-lg rounded-lg">
        <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
            🔗 {getMessage('app.title')}
          </h1>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
            📝 {getMessage('register.title')}
          </h2>
        </div>
        
        <input 
          name="name" 
          placeholder={getMessage('register.name_placeholder')} 
          className="w-full mb-3 p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:text-white" 
          onChange={handleChange} 
        />
        <input 
          name="email" 
          type="email"
          placeholder={getMessage('register.email_placeholder')} 
          className="w-full mb-3 p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:text-white" 
          onChange={handleChange} 
        />
        <input 
          name="password" 
          type="password" 
          placeholder={getMessage('register.password_placeholder')} 
          className="w-full mb-4 p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:text-white" 
          onChange={handleChange} 
        />
        
        <button 
          onClick={handleRegister} 
          className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-medium transition-colors duration-200"
        >
          {getMessage('register.register_button')}
        </button>
        
        {message && (
          <p className="mt-4 text-center text-sm p-2 rounded bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
